export const convertGender = (gender) => {
  switch (gender) {
    case "M":
      return "남";
    case "F":
      return "여";
    default:
      return null;
  }
};

export const convertAppLinkStatus = (status) => {
  switch (status) {
    case "A":
      return "연동완료";
    case "D":
      return "연동거절";
    default:
      return null;
  }
};

export const calculateAge = (birthyear) => {
  if (birthyear === null || birthyear === undefined) return 0;
  const currentYear = new Date().getFullYear();
  return Math.abs(currentYear - Number(birthyear));
};
